import React from 'react';
import './section2-p2.css';
import FilterBar from '../components/common/FilterBar';
import PropertyCard from '../components/common/PropertyCard';

import img1 from '../assets/property1.png';
import img2 from '../assets/property2.png';
import img3 from '../assets/property3.png';
import img4 from '../assets/property4.png';
import img5 from '../assets/property5.png';
import img6 from '../assets/property6.png';
import img7 from '../assets/property7.png';
import img8 from '../assets/property8.png';
import { Link } from 'react-router-dom';
const SectionTwo = () => {
  const properties = [
    { id: 1, title: "Verde Heights New Villa", loc: "Villa in Hyde Park, Cairo", price: "46,000,000", beds: 4, baths: 2, area: 600, img: img1 },
    { id: 2, title: "Royal Horizon Villa", loc: "Villa in Sheikh Zayed, Cairo", price: "32,400,000", beds: 3, baths: 2, area: 740, img: img2 },
    { id: 3, title: "Emerald Valley Villa", loc: "Villa in Fifth Settlement, Cairo", price: "52,750,000", beds: 4, baths: 3, area: 950, img: img3 },
    { id: 4, title: "Azure Park Villa", loc: "Villa in Hyde Park, Cairo", price: "75,750,000", beds: 4, baths: 2, area: 880, img: img4 },
    { id: 5, title: "Silver Grove Villa", loc: "Villa in Mostakbal City, Cairo", price: "26,750,000", beds: 2, baths: 2, area: 650, img: img5 },
    { id: 6, title: "Imperial Crest Villas", loc: "Villa in Sheikh Zayed, Cairo", price: "85,790,000", beds: 3, baths: 2, area: 980, img: img6 },
    { id: 7, title: "Vista Royale Villa", loc: "Villa in Fifth Settlement, Cairo", price: "42,750,000", beds: 3, baths: 2, area: 710, img: img7 },
    { id: 8, title: "Opal Heights Villas", loc: "Villa in Hyde Park, Cairo", price: "27,024,000", beds: 2, baths: 2, area: 594, img: img8 },
  ];

  return (
    <section className="properties-list-sec">
      <div className="container-sec2p2">
        <FilterBar />
        <h2 className="grid-title">Available Properties:</h2>
        
        <div className="properties-grid">
  {properties.map((item) =>
    item.id === 1 ? (
      <Link to="/Propertydetails"  key={item.id}>
        <PropertyCard 
          title={item.title}
          location={item.loc}
          price={item.price}
          beds={item.beds}
          baths={item.baths}
          area={item.area}
          image={item.img}
        />
      </Link>
    ) : (
      <PropertyCard 
        key={item.id}
        title={item.title}
        location={item.loc}
        price={item.price}
        beds={item.beds}
        baths={item.baths}
        area={item.area}
        image={item.img}
      />
    )
  )}
</div>
      </div>
    </section>
  );
};

export default SectionTwo;